import { useOccupationalHealthStore } from "@/store/occupational-health-store"

async function handleLogOutEvent() {
  useOccupationalHealthStore().clearOhrCount()
}

export default {
  handleLogOutEvent
}
